import React from "react";
import { StarIconContainer } from "./index.styled";
import { colors } from "../../../styles/colors";

interface StarIconProps {
  size?: number;
  color?: string;
  filled?: boolean;
  className?: string;
}

const StarIcon: React.FC<StarIconProps> = ({
  size = 24,
  color = "currentColor",
  filled = false,
  className,
}) => {
  return (
    <StarIconContainer
      size={size}
      color={color}
      $filled={filled}
      className={className}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={filled ? "currentColor" : colors.lightBlueGray}
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
      </svg>
    </StarIconContainer>
  );
};

export default StarIcon;
